export function sortByKey(array, key) {
    return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}

// WindTurbine.latitude/longitude are free-text (see Orbital-admin's plain
// TextInput) - some turbines were entered in DMS form (e.g. 40°26'46.2"N,
// copy-pasted straight from Google Maps) instead of decimal degrees.
// parseFloat() alone silently truncates that to just the leading integer
// (WindTurbinesMap.js's old behavior - a turbine renders at the wrong spot
// with no error), and OpenWeatherMap's API 400s on it outright (weather.js).
// Handles both forms so either one works everywhere coordinates are used.
const DMS_PATTERN = /^(\d+)[°\s](\d+)['\s]([\d.]+)["\s]?\s*([NSEW])$/i;

export function parseCoordinate(value) {
    if (value === null || value === undefined) return NaN;
    const dmsMatch = String(value).trim().match(DMS_PATTERN);
    if (dmsMatch) {
        const [, degrees, minutes, seconds, direction] = dmsMatch;
        const decimal = Number(degrees) + Number(minutes) / 60 + Number(seconds) / 3600;
        return (direction.toUpperCase() === 'S' || direction.toUpperCase() === 'W') ? -decimal : decimal;
    }
    return parseFloat(value);
}
